import {default as init} from "surveylabJsAssets/chart/charts";
import {setDefaultOptions} from "sdbbJsAssets/chart/charts";

export default function () {
    setDefaultOptions({
        colors: ['#cc0066'],
    });

    init();
}